var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PerfectScrollbar',{ref:"perfectScrollbar",attrs:{"tag":_vm.htmlTag},on:{"ps-y-reach-end":function($event){return _vm.$emit('roll-to-the-bottom')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }